import React from 'react';

interface UseStepOneTermReplacementRestrictionResult {
  isTermReplacementRestricted: boolean;
  isTermReplacementStatusLoading: boolean;
  handleTermReplacementRestrictionChange: (isRestricted: boolean, isLoading: boolean) => void;
}

export const useStepOneTermReplacementRestriction =
  (): UseStepOneTermReplacementRestrictionResult => {
    const [isTermReplacementRestricted, setIsTermReplacementRestricted] = React.useState(false);
    const [isTermReplacementStatusLoading, setIsTermReplacementStatusLoading] =
      React.useState(false);

    const handleTermReplacementRestrictionChange = React.useCallback(
      (isRestricted: boolean, isLoading: boolean) => {
        setIsTermReplacementRestricted(isRestricted);
        setIsTermReplacementStatusLoading(isLoading);
      },
      []
    );

    return {
      isTermReplacementRestricted,
      isTermReplacementStatusLoading,
      handleTermReplacementRestrictionChange,
    };
  };
